import React from 'react'
import HeaderDisclaimerText from './styled-components/HeaderDisclaimerText'

export const GoogleAssistantDisclaimer = (props) => {
  return (
    <>
      {props.clientID === 'ANOVA_OVEN_GOOGLE_HOME' && <HeaderDisclaimerText>
        By signing in, you are authorizing<br />
        Google to access your devices.<br />
      </HeaderDisclaimerText>}
    </>
  )
}